/**
 * @Description:仓库公共minxin
 * @Author: lufenggang
 * @LastEditors: lufenggang
 * @Date: 2019/6/17
 * @LastEditTime: 2019/7/25
 */
export default {
    methods: {
        //获取仓库/区位/监测点树形列表
        async getStorageLocationPointTreeList() {
            try {
                let res = await this.coldChainApi.getStorageLocationPointTreeData();
                let locationStorageTree = [];
                if (res.result) {
                    if (res.result && Array.isArray(res.result)) {
                        locationStorageTree = res.result;
                    }
                }
                //判断是否是从仓库监控页面跳转过来的
                if (this.pPointId) {
                    //勾选默认监测点
                    this.$refs["pointTree"].setSelectList(this.pPointId.split(" "));
                }
                this.locationStoragePointList = this.cloneDeep(locationStorageTree);
                return true;
            } catch (err) {
                console.log(err);
                throw new Error(err);
            }
        },

        //获取监测点下拉树数据
        async getPointTypeTreeList() {
            try {
                let res = await this.coldChainApi.getPointTypeTreeData();
                let pointTypeTree = [];
                if (res.result) {
                    if (res.result && Array.isArray(res.result)) {
                        pointTypeTree = res.result;
                    }
                }
                this.pointTypeTreeList = this.cloneDeep(pointTypeTree);
                return true;
            } catch (err) {
                console.log(err);
                throw new Error(err);
            }
        },

        //设置报警的在线状态
        setAlarmStatus(pStatus) {
            var obj = {};
            switch (pStatus) {
                case 0:
                    obj.statusName = "关闭 ";
                    obj.statusClass = "onClose";
                    break;
                case 1:
                    obj.statusName = "开启";
                    obj.statusClass = "onOpen";
                    break;
                default:
            }
            return obj;
        },
        //获取报警等状态
        getAlarmState(item, type) {
            let obj = {};
            //判断报警等级   0预警 1一级 2二级 3三级(预警只有一级，报警才有一二三级)
            if (item[type + "AlarmLevel"] == 1) {
                obj.iconClass = "e6-icon-grade-_fill2";
                obj.alarmColor = "#f56c6c";
            } else if (item[type + "AlarmLevel"] == 2) {
                obj.iconClass = "e6-icon-grade-_fill1";
                obj.alarmColor = "#f56c6c";
            } else if (item[type + "AlarmLevel"] == 3) {
                obj.iconClass = "e6-icon-grade-_fill";
                obj.alarmColor = "#f56c6c";
            } else {
                obj.iconClass = "e6-icon-grade-_fill2";
                obj.alarmColor = "#e6a23c";
            }
            //判断是超高还是超低等级（无 = 0,超高温 = 1,超低温 = 2,超高湿 = 3,超低湿 = 4）
            if (item[type + "AlarmStatus"] == 1 || item[type + "AlarmStatus"] == 3) {
                obj.levelClass = "";
            } else if (
                item[type + "AlarmStatus"] == 2 ||
                item[type + "AlarmStatus"] == 4
            ) {
                obj.levelClass = "rotate";
            } else {
                obj.levelClass = "";
                obj.iconClass = "e6-icon-grade_hide";
                obj.alarmColor = "#000";
            }
            return obj;
        },
        //验证是否是整数或者小数
        isNum(str, max, min) {
            let res = false;
            let floatReg = /^(-?\d+)(\.\d+)?$/;
            let intReg = /^-?\d+$/;
            if (floatReg.test(str) || intReg.test(str)) {
                let num = parseFloat(str);
                if (num <= max && num >= min) {
                    res = true;
                }
            }
            return res;
        },
        //监测点树形列表
        async getFreezerPointTree(params) {
            try {
                let res = await this.coldChainApi.getFreezerPointTree(params);
                let locationStorageTree = [];
                if (res.result) {
                    if (res.result && Array.isArray(res.result)) {
                        locationStorageTree = res.result;
                    }
                }
                //判断是否是从仓库监控页面跳转过来的
                if (this.pPointId && this.isCheck) {
                    //勾选默认监测点
                    this.$refs["pointTree"].setSelectList(this.pPointId.split(" "));
                    this.isCheck = false;
                }
                this.locationStoragePointList = this.cloneDeep(locationStorageTree);
                return true;
            } catch (err) {
                console.log(err);
                throw new Error(err);
            }
        }
    }
};
